import { render, staticRenderFns } from "./ApproveDetailDialog.vue?vue&type=template&id=10a2c078&scoped=true"
import script from "./ApproveDetailDialog.vue?vue&type=script&lang=js"
export * from "./ApproveDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2c078",
  null
  
)

export default component.exports